const I18n = globalThis.I18n ??= {};
I18n.defaultLocale = "en";
I18n.locale = document.documentElement.getAttribute("lang");
I18n.translations = {};
